import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { StudentProgramme } from '@types';

export interface ProgrammeState {
    current: StudentProgramme | null;
}

const initialState: ProgrammeState = {
    current: null,
};

const programmeSlice = createSlice({
    name: 'programme',
    initialState,
    reducers: {
        currentProgrammeUpdated: (
            state,
            { payload }: PayloadAction<StudentProgramme>,
        ) => {
            state.current = payload;
        },
    },
});

export const { currentProgrammeUpdated } = programmeSlice.actions;

export const currentProgrammeSelector = (state: {
    programme: ProgrammeState;
}) => state.programme.current;

export const programmeSubjectDirectoriesSelector = (state: {
    programme: ProgrammeState;
}) => state.programme.current?.subject_directories;

export const programmeNameSelector = (state: { programme: ProgrammeState }) =>
    state.programme.current?.name;

export const userWelcomeRequiredSelector = createSelector(
    currentProgrammeSelector,
    (currentProgramme) => {
        const isWelcomeRequired =
            currentProgramme && !currentProgramme?.onboarding_completed;

        if (isWelcomeRequired) {
            return true;
        }

        // if welcome stage is completed (or if the programme object did not load yet) this should not trigger redirect
        return false;
    },
);

export const programmeIntroLOCompletedSelector = (state: {
    programme: ProgrammeState;
}) => state.programme.current?.intro_lo_completed;

export default programmeSlice.reducer;
